import { CircularProgress, Divider, Grid, makeStyles } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getRUCEmpresa } from "redux/actions/userActions";
import TablePaginatedPay from "widgets/Tables/TablePaginatedPay";
import TablePaginatedSearchPay from "widgets/Tables/TablePaginatedSearchPay";
import TableSimple from "widgets/Tables/TableSimple";
import { CardGeneric } from "../components/CardGeneric";
import {
  API_GET_ALL_COMPANY,
  API_GET_ALL_COMPANY_2,
  API_GET_SEARCH_COMPANY,
  API_GET_SEARCH_ALL_COMPANY,
} from "./apis";
import AddCompanyBtn from "./Buttons/AddCompanyBtn";
import tableStyle from "configurations/styles/table";
import GenerateReportsBtn from "./Buttons/GenerateReportsBtn";
import GenerateReportIssuedBtn from "./Buttons/GenerateReportIssuedBtn";
import SearchCompany from "./Forms/SearchCompany";
import SearchCompanyAdvanced from "./Forms/SearchCompanyAdvanced"
import clientBackend, { clientPay } from "configurations/axios";
import EditCompanyBtn from "./Buttons/EditCompanyBtn";
import UpVouchersIssuedBtn from "./Buttons/UpVouchersIssuedBtn";
import AsignarComprobantes from "./Buttons/AsignarComprobantes";
import InfoCompanyBtn from "./Buttons/InfoCompany";
import AsignarPerfilPartner from "./Buttons/AsignarPerfilPartner";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: "35px",
    paddingBottom: "7%",
    flexGrow: 1,
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  headerBottons: {
    padding: "0.5%",
  },
  loader: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    height: "300px",
  },
}));

const Company = () => {
  const tokenUser = useSelector((state) => state.user.tk);
  const classesView = useStyles();
  const [update, setUpdate] = useState(0);
  const [paramSearch, setParamSearch] = useState("");
  const [foundCompany, setFoundCompany] = useState([]);

  
  const getParam = (data) => {
    setParamSearch(data);
    if (data.length > 0) {
      searchCompany(data);
    } else {
      reload();
    }
  };


  const columns = [
    {
      title: "RUC",
      field: "idempresacontratante",
      cellStyle: tableStyle.cellTable,
      width: "8%",
    },
    {
      title: "Razón Social/Nombres",
      field: "razonSocialempresa",
      cellStyle: tableStyle.cellLeft,
     },
    // {
    //   title: "Correo",
    //   field: "correo",
    //   cellStyle: tableStyle.cellLeft,
    // },
    // {
    //   title: "Fecha registro	",
    //   field: "fechaRegistro",
    //   cellStyle: tableStyle.cellTable,
    //   width: "6%",
    //   render: (rowData) => rowData.fechaRegistro.substring(0, 10),
      
    // },
    {
      title: "Rep. Comp. Emitidos",
      cellStyle: tableStyle.cellTable,
      render: (rowData) => <GenerateReportIssuedBtn data={rowData} />,
      
    },
    // {
    //   title: "# Comp. Emitidos",
    //   field: "comprobantesUtilizados",
    //   cellStyle: tableStyle.cellLeft,
    // },
    {
      title: "# Comp. Disponibles",
      field: "comprobantesDisponibles",
      cellStyle: tableStyle.cellLeft,
    },
    {
      title: "Tipo Pago",
      field: "tipoContratacion",
      cellStyle: tableStyle.cellLeft,
    },
    {
      title: "Empresa Contadora",
      field: "idempresacontadora",
      cellStyle: tableStyle.cellLeft,
    },
    {
      title: "Partner",
      field: "esPartner",
      cellStyle: tableStyle.cellLeft,
    },
    {
      title: "Ver Información",
      cellStyle: tableStyle.cellTable,
      width: "7%",
      render: (rowData) => <InfoCompanyBtn company={rowData} />,
    },
    // {
    //   title: "Editar",
    //   cellStyle: tableStyle.cellTable,
    //   render: (rowData) => <EditCompanyBtn data={rowData} reload={reload} />,
    // },
    
  ];

  const requestConfig = {
    uri: API_GET_ALL_COMPANY,
    metodo: "get",
    body: null,
    page: 0,
    elementos: 15,
    sort: "idempresacontratante,desc",
  };

  const requestConfigSearch = {
    uri: API_GET_SEARCH_ALL_COMPANY,
    metodo: "get",
    body: null,
    page: 0,
    elementos: 15,
    sort: "idempresacontratante,desc",
  };

  const reload = () => {
    setParamSearch("");
    setUpdate(1);
};
useEffect(() => {
  if (update === 1) {
    setUpdate(0);
  }
}, [update]);


  const searchCompany = async (param) => {
    setUpdate(3);
    await clientPay
      .get(
        API_GET_SEARCH_COMPANY +
          "?parametroBusqueda=" +
          param
      )
      .then((response) => {
        if (response.status === 200) {
          setFoundCompany(response.data);
          setUpdate(2);
        }
      })
      .catch((exception) => {
        console.error({ exception });
      });
  };


  const renderTable = () => {
    switch (update) {
      case 0:
        return (
          <TablePaginatedPay
            title=""
            columns={columns}
            requestConfig={requestConfig}
          />
        );

      case 1:
      case 3:
        return (
          <div className={classesView.loader}>
            <CircularProgress />
          </div>
        );
      case 2:
        return (
          <TableSimple
            columns={columns}
            data={foundCompany}
            title=""
            numberRowsPerPage={15}
          />
        );
        case 4:
        return (
            <TablePaginatedSearchPay
              title=""
              columns={columns}
              requestConfig={requestConfigSearch}
              paramSearch={paramSearch}
              seleccion={false}
              numberRowsPerPage={15}
              />
        );
      default:
        break;
    }
  };

  return (
    <div className={classesView.root}>
      <CardGeneric>
        <Grid container spacing={1}>
          <Grid item xs={12} md={12}>
            {<AddCompanyBtn updateView={reload} />}
          </Grid>
          <Grid item xs={12} md={12}>
            {<AsignarPerfilPartner updateView={reload} />}
          </Grid>
          <Grid item xs={12} md={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} md={9} className={classesView.headerBottons}>
            <SearchCompany backupParam={paramSearch} sendData={getParam} />
          </Grid>
          <Grid item xs={12} md={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} md={12} className={classesView.headerBottons}>
            {
              <SearchCompanyAdvanced
                update={update}
                setUpdate={setUpdate}
                setParamSearch={setParamSearch}
              />
            }
          </Grid>
        </Grid>
      </CardGeneric>
      {renderTable()}
    </div>
  );
};

export default Company;